






import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    loading: {
      type: Boolean as () => boolean,
    },
  },
});
